import { studioExecutionApi, studioVisualizationsApi } from '@blockworks/platform/api/research/studio';

import type { MergedVisualizationExecutionData } from '../models';

import { getTableVisualizationPageSize } from './get-table-visualization-page-size';

type UseMergeVisualizationOpts = {
    visualizationId: string;
};

const useGetMergedVisualizationAndExecution = ({ visualizationId }: UseMergeVisualizationOpts) => {
    const visualization = studioVisualizationsApi.useGetVisualization({
        variables: { id: visualizationId! },
        select: ({ data, _meta }) => ({ ...data, _meta }),
        enabled: !!visualizationId,
    });

    const maybeTablePageSize = getTableVisualizationPageSize(visualization?.data?.config);
    const execution = studioExecutionApi.useGetExecution({
        variables: {
            id: visualization?.data?.lastExecutionId as string,
            limit: maybeTablePageSize,
        },
        enabled: !!visualization?.data?.lastExecutionId,
        select: studioExecutionApi.select.asSingle,
    });

    return {
        data: {
            ...visualization?.data!,
            config: visualization?.data?.config!,
            execution: execution.data!,
        } satisfies MergedVisualizationExecutionData,
        visualization,
        execution,
    };
};

export { useGetMergedVisualizationAndExecution };
